(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.TanhoodCollection) return;

  var MQ = window.matchMedia('(max-width: 989px)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var esc = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var debounce = function (fn, wait) {
    var t;
    return function () { var a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(null, a); }, wait); };
  };
  var visible = function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); };

  var ICON_MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5v14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linejoin="round"/></svg>';

  function CartError(message) { this.name = 'CartError'; this.message = message; }
  CartError.prototype = Object.create(Error.prototype);

  function Collection(root) {
    this.root = root;
    this.cfg = JSON.parse(qs('[data-tc-config]', root).textContent);
    this.s = this.cfg.strings;
    this.form = qs('[data-tc-filter-form]', root);
    this.sortInput = qs('[data-tc-sort-input]', root);
    this.overlay = qs('[data-tc-overlay]', root);
    this.toastEl = qs('[data-tc-toast]', root);
    this.cache = new Map();
    this.life = new AbortController();
    this.fetchAbort = null;
    this.requestId = 0;
    this.openName = null;
    this.lastFocus = null;
    this.qv = null;
    this.qvTrigger = null;
    this.currentKey = location.pathname + location.search;
    this.submitSoon = debounce(this.applyFilters.bind(this), 650);
    this.bind();
    this.paintPrice();
  }

  Collection.prototype.bind = function () {
    var self = this;
    var sig = { signal: this.life.signal };
    this.root.addEventListener('click', function (e) { self.onClick(e); }, sig);
    this.root.addEventListener('change', function (e) { self.onChange(e); }, sig);
    this.root.addEventListener('input', function (e) { self.onInput(e); }, sig);
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.applyFilters(); }, sig);
    window.addEventListener('popstate', function () { self.onPopState(); }, sig);
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.resetButtons(); }, sig);
    document.addEventListener('keydown', function (e) { self.onKeydown(e); }, sig);
    document.addEventListener('click', function (e) { self.onDocClick(e); }, { signal: this.life.signal, capture: true });
    if (MQ.addEventListener) {
      MQ.addEventListener('change', function () {
        if (self.openName === 'filters' || self.openName === 'sort') self.closePanel(false);
      }, sig);
    }
  };

  Collection.prototype.destroy = function () { this.life.abort(); };

  /* ---------------------------- Events ---------------------------- */
  Collection.prototype.onClick = function (e) {
    var t = e.target, el;
    if (t.matches('[data-tc-overlay]')) { this.closePanel(); return; }
    if ((el = t.closest('[data-tc-checkout-btn]'))) { e.preventDefault(); this.goToCheckout(null); return; }
    if ((el = t.closest('[data-tc-clear]'))) { e.preventDefault(); this.clearAll(); return; }
    if ((el = t.closest('a[data-tc-link]'))) { e.preventDefault(); this.render(el.href, { scroll: el.hasAttribute('data-tc-scroll') }); return; }
    if ((el = t.closest('[data-tc-sort]'))) { e.preventDefault(); this.setSort(el.getAttribute('data-tc-sort')); return; }
    if ((el = t.closest('[data-tc-open]'))) {
      e.preventDefault();
      var name = el.getAttribute('data-tc-open');
      if (this.openName === name) this.closePanel(); else this.openPanel(name, el);
      return;
    }
    if ((el = t.closest('[data-tc-close]'))) { e.preventDefault(); this.closePanel(); return; }
    if ((el = t.closest('[data-tc-add]'))) { e.preventDefault(); this.cardAction(el, 'add'); return; }
    if ((el = t.closest('[data-tc-buy]'))) { e.preventDefault(); this.cardAction(el, 'buy'); return; }
    if ((el = t.closest('[data-tc-quickview]'))) { e.preventDefault(); this.openQuickView(el.getAttribute('data-handle'), el); return; }
    if ((el = t.closest('[data-tc-wishlist]'))) { e.preventDefault(); this.toggleWishlist(el); return; }
    if ((el = t.closest('[data-tc-line-step]'))) { e.preventDefault(); this.stepLine(el); return; }
    if ((el = t.closest('[data-tc-remove]'))) { e.preventDefault(); this.changeLine(el.getAttribute('data-key'), 0); return; }
    if ((el = t.closest('[data-tc-qv-step]'))) { e.preventDefault(); this.stepQv(Number(el.getAttribute('data-tc-qv-step'))); return; }
    if ((el = t.closest('[data-tc-qv-add]'))) { e.preventDefault(); this.qvSubmit('add', el); return; }
    if ((el = t.closest('[data-tc-qv-buy]'))) { e.preventDefault(); this.qvSubmit('buy', el); return; }
  };

  Collection.prototype.onDocClick = function (e) {
    var sel = this.cfg.headerCartSelector;
    if (this.cfg.cartDrawer && sel) {
      var hit = null;
      try { hit = e.target.closest(sel); } catch (_) { hit = null; }
      if (hit && !this.root.contains(hit)) {
        e.preventDefault();
        e.stopPropagation();
        this.openCart(hit);
        return;
      }
    }
    if (this.openName === 'sort' && !MQ.matches) {
      var wrap = qs('[data-tc-sort-wrap]', this.root);
      if (wrap && !wrap.contains(e.target)) this.closePanel(false);
    }
  };

  Collection.prototype.onChange = function (e) {
    var t = e.target;
    if (t.matches('[data-tc-qv-option]')) { this.onQvOption(); return; }
    if (!this.form || !this.form.contains(t)) return;
    this.applyFilters();
  };

  Collection.prototype.onInput = function (e) {
    var t = e.target;
    if (t.matches('[data-tc-range]')) { this.syncFromRange(t); return; }
    if (t.matches('[data-tc-price-input]')) { this.syncFromInput(t); this.submitSoon(); }
  };

  Collection.prototype.onKeydown = function (e) {
    if (!this.openName) return;
    if (e.key === 'Escape') { e.preventDefault(); this.closePanel(); return; }
    if (e.key !== 'Tab' || !this.isModal(this.openName)) return;
    var panel = this.panel(this.openName);
    if (!panel) return;
    var items = qsa(FOCUSABLE, panel).filter(visible);
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Collection.prototype.onPopState = function () {
    var key = location.pathname + location.search;
    if (key === this.currentKey) return;
    this.render(location.href, { push: false });
  };

  /* ---------------------------- Filters / sort ---------------------------- */
  Collection.prototype.priceParts = function (el) {
    var wrap = el.closest('[data-tc-price]');
    return {
      wrap: wrap,
      max: Number(wrap.getAttribute('data-max')),
      rMin: qs('[data-tc-range="min"]', wrap),
      rMax: qs('[data-tc-range="max"]', wrap),
      iMin: qs('[data-tc-price-input="min"]', wrap),
      iMax: qs('[data-tc-price-input="max"]', wrap)
    };
  };

  Collection.prototype.syncFromRange = function (range) {
    var p = this.priceParts(range);
    if (Number(p.rMin.value) > Number(p.rMax.value)) {
      if (range === p.rMin) p.rMin.value = p.rMax.value; else p.rMax.value = p.rMin.value;
    }
    p.iMin.value = Number(p.rMin.value) > 0 ? p.rMin.value : '';
    p.iMax.value = Number(p.rMax.value) < p.max ? p.rMax.value : '';
    this.paintPrice(p.wrap);
  };

  Collection.prototype.syncFromInput = function (input) {
    var p = this.priceParts(input);
    var lo = p.iMin.value === '' ? 0 : Math.max(0, Math.min(p.max, Number(p.iMin.value) || 0));
    var hi = p.iMax.value === '' ? p.max : Math.max(0, Math.min(p.max, Number(p.iMax.value) || 0));
    p.rMin.value = lo;
    p.rMax.value = hi;
    this.paintPrice(p.wrap);
  };

  Collection.prototype.paintPrice = function (only) {
    (only ? [only] : qsa('[data-tc-price]', this.root)).forEach(function (wrap) {
      var max = Number(wrap.getAttribute('data-max')) || 1;
      var lo = Number(qs('[data-tc-range="min"]', wrap).value);
      var hi = Number(qs('[data-tc-range="max"]', wrap).value);
      var fill = qs('[data-tc-price-fill]', wrap);
      fill.style.left = (Math.min(lo, hi) / max) * 100 + '%';
      fill.style.right = (100 - (Math.max(lo, hi) / max) * 100) + '%';
    });
  };

  Collection.prototype.baseUrl = function () {
    var action = this.form ? this.form.getAttribute('action') : location.pathname;
    return new URL(action || location.pathname, location.origin);
  };

  Collection.prototype.buildFilterUrl = function () {
    var url = this.baseUrl();
    var params = new URLSearchParams();
    if (this.form) {
      var prices = {};
      qsa('[data-tc-price-input]', this.form).forEach(function (i) { prices[i.name] = i; });
      new FormData(this.form).forEach(function (value, key) {
        var v = String(value).trim();
        if (v === '') return;
        var priceInput = prices[key];
        if (priceInput) {
          var n = Number(v);
          var max = Number(priceInput.closest('[data-tc-price]').getAttribute('data-max'));
          if (!isFinite(n)) return;
          if (priceInput.getAttribute('data-tc-price-input') === 'min' && n <= 0) return;
          if (priceInput.getAttribute('data-tc-price-input') === 'max' && n >= max) return;
          v = String(Math.round(n));
        }
        params.append(key, v);
      });
    } else if (this.sortInput && this.sortInput.value) {
      params.set('sort_by', this.sortInput.value);
    }
    url.search = params.toString();
    return url;
  };

  Collection.prototype.applyFilters = function () { this.render(this.buildFilterUrl().href); };

  Collection.prototype.setSort = function (value) {
    if (this.sortInput) this.sortInput.value = value;
    this.closePanel(false);
    if (this.form) { this.applyFilters(); return; }
    var url = new URL(location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    this.render(url.href);
  };

  Collection.prototype.clearAll = function () {
    var url = this.baseUrl();
    if (this.sortInput && this.sortInput.value) url.searchParams.set('sort_by', this.sortInput.value);
    if (this.openName === 'filters') this.closePanel(false);
    this.render(url.href, { scroll: true });
  };

  /* ---------------------------- Section rendering ---------------------------- */
  Collection.prototype.render = async function (href, opts) {
    opts = opts || {};
    var target = new URL(href, location.origin);
    target.hash = '';
    var key = target.pathname + target.search;
    if (opts.push !== false && key === this.currentKey) return;

    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', this.cfg.sectionId);

    if (this.fetchAbort) this.fetchAbort.abort();
    this.fetchAbort = new AbortController();
    var id = ++this.requestId;
    this.setLoading(true);

    try {
      var html = this.cache.get(fetchUrl.href);
      if (!html) {
        var res = await fetch(fetchUrl.href, { signal: this.fetchAbort.signal, credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        html = await res.text();
        this.cache.set(fetchUrl.href, html);
      }
      if (id !== this.requestId) return;
      this.swap(html);
      this.currentKey = key;
      if (opts.push !== false) history.pushState({ tanhood: true }, '', key);
      if (opts.scroll) this.scrollToResults();
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      // Never leave the page broken — fall back to a normal page load of the same URL.
      window.location.assign(target.href);
    } finally {
      if (id === this.requestId) this.setLoading(false);
    }
  };

  Collection.prototype.swap = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-tc-root]', doc);
    if (!fresh) throw new Error('Section markup missing');
    var state = this.captureState();

    var pool = {};
    qsa('[data-tc-region]', fresh).forEach(function (el) {
      var n = el.getAttribute('data-tc-region');
      (pool[n] = pool[n] || []).push(el);
    });
    var seen = {};
    qsa('[data-tc-region]', this.root).forEach(function (el) {
      var n = el.getAttribute('data-tc-region');
      seen[n] = n in seen ? seen[n] + 1 : 0;
      var src = pool[n] && pool[n][seen[n]];
      if (src) el.innerHTML = src.innerHTML;
    });

    var freshSort = qs('[data-tc-sort-input]', fresh);
    if (freshSort && this.sortInput) this.sortInput.value = freshSort.value;

    this.restoreState(state);
    this.paintPrice();

    // Judge.me: if its badge script is loaded, let it re-process badges injected via AJAX.
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (_) {}
    }
    this.root.dispatchEvent(new CustomEvent('tanhood:collection:updated', { bubbles: true }));
  };

  Collection.prototype.captureState = function () {
    var open = {};
    qsa('details[data-tc-key]', this.root).forEach(function (d) { open[d.getAttribute('data-tc-key')] = d.open; });
    var a = document.activeElement;
    var focusId = a && a.id && this.root.contains(a) ? a.id : null;
    var sel = null;
    try { if (focusId && typeof a.selectionStart === 'number') sel = a.selectionStart; } catch (_) {}
    var scroller = qs('[data-tc-filter-scroll]', this.root);
    return { open: open, focusId: focusId, sel: sel, scroll: scroller ? scroller.scrollTop : 0 };
  };

  Collection.prototype.restoreState = function (st) {
    qsa('details[data-tc-key]', this.root).forEach(function (d) {
      var k = d.getAttribute('data-tc-key');
      if (k in st.open) d.open = st.open[k];
    });
    var scroller = qs('[data-tc-filter-scroll]', this.root);
    if (scroller) scroller.scrollTop = st.scroll;
    if (st.focusId) {
      var el = document.getElementById(st.focusId);
      if (el) {
        el.focus({ preventScroll: true });
        try { if (st.sel !== null) el.setSelectionRange(st.sel, st.sel); } catch (_) {}
      }
    }
  };

  Collection.prototype.setLoading = function (on) {
    this.root.classList.toggle('tc--loading', on);
    var grid = qs('[data-tc-region="grid"]', this.root);
    if (grid) grid.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  Collection.prototype.scrollToResults = function () {
    var el = qs('[data-tc-results]', this.root);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED.matches ? 'auto' : 'smooth' });
  };

  /* ---------------------------- Panels ---------------------------- */
  Collection.prototype.panel = function (name) { return qs('[data-tc-panel="' + name + '"]', this.root); };
  Collection.prototype.isModal = function (name) { return name === 'cart' || name === 'quickview' || MQ.matches; };

  Collection.prototype.openPanel = function (name, trigger) {
    var p = this.panel(name);
    if (!p) return;
    if (this.openName && this.openName !== name) this.closePanel(false);
    if (!this.lastFocus || this.openName === null) this.lastFocus = trigger || document.activeElement;
    this.openName = name;
    p.classList.add('is-open');

    if (this.isModal(name)) {
      if (name === 'filters' || name === 'sort') { p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true'); }
      if (this.overlay) {
        var ov = this.overlay;
        ov.hidden = false;
        requestAnimationFrame(function () { ov.classList.add('is-visible'); });
      }
      document.documentElement.classList.add('tc-scroll-lock');
    }
    qsa('[data-tc-open="' + name + '"]', this.root).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function () {
      var f = qs('[data-tc-autofocus]', p);
      if (!f || !visible(f)) f = qsa(FOCUSABLE, p).filter(visible)[0] || p;
      f.focus({ preventScroll: true });
    });
  };

  Collection.prototype.closePanel = function (restoreFocus) {
    var name = this.openName;
    if (!name) return;
    var p = this.panel(name);
    if (p) {
      p.classList.remove('is-open');
      if (name === 'filters' || name === 'sort') { p.removeAttribute('role'); p.removeAttribute('aria-modal'); }
    }
    qsa('[data-tc-open="' + name + '"]', this.root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    this.openName = null;
    if (this.overlay) {
      var ov = this.overlay, self = this;
      ov.classList.remove('is-visible');
      setTimeout(function () { if (!self.openName) ov.hidden = true; }, 260);
    }
    document.documentElement.classList.remove('tc-scroll-lock');
    if (restoreFocus !== false && this.lastFocus && document.contains(this.lastFocus)) {
      this.lastFocus.focus({ preventScroll: true });
    }
    this.lastFocus = null;
  };

  /* ---------------------------- Money ---------------------------- */
  Collection.prototype.money = function (cents) {
    var fmt = this.cfg.moneyFormat || '{{amount}}';
    var value = Number(cents) || 0;
    var fmtNum = function (num, precision, thousands, decimal) {
      var parts = (num / 100).toFixed(precision).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNum(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(value, 0, ' ', '');
        case 'amount_with_space_separator': return fmtNum(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmtNum(value, 2, ' ', '.');
        default: return fmtNum(value, 2, ',', '.');
      }
    });
  };

  Collection.prototype.sized = function (src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', width);
      return u.href;
    } catch (_) { return src; }
  };

  /* ---------------------------- Cart API ---------------------------- */
  Collection.prototype.request = async function (url, body) {
    var res;
    try {
      res = await fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      });
    } catch (_) {
      throw new CartError(this.s.network);
    }
    var data = null;
    try { data = await res.json(); } catch (_) {}
    if (!res.ok) {
      var msg = data && typeof data.description === 'string' ? data.description
        : data && typeof data.message === 'string' ? data.message : null;
      throw new CartError(msg && msg.length < 200 ? msg : this.s.error);
    }
    return data;
  };

  Collection.prototype.getCart = function () { return this.request(this.cfg.routes.cart + '.js'); };
  Collection.prototype.addItem = function (id, quantity) {
    var vid = Number(id);
    if (!vid) return Promise.reject(new CartError(this.s.error));
    return this.request(this.cfg.routes.cartAdd + '.js', { items: [{ id: vid, quantity: Math.max(1, quantity | 0) }] })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return data;
      });
  };

  Collection.prototype.errMsg = function (err) { return err instanceof CartError ? err.message : this.s.error; };

  Collection.prototype.setBtn = function (btn, state, label) {
    if (!btn) return;
    if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.textContent.trim());
    if (state === 'idle') {
      btn.textContent = btn.getAttribute('data-label');
      btn.removeAttribute('aria-busy');
      btn.disabled = btn.hasAttribute('data-soldout');
      return;
    }
    btn.textContent = label;
    btn.disabled = true;
    if (state === 'busy') btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  };

  Collection.prototype.resetButtons = function () {
    var self = this;
    qsa('[data-label]', this.root).forEach(function (b) { self.setBtn(b, 'idle'); });
  };

  Collection.prototype.cardAction = async function (btn, mode) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    if (btn.getAttribute('data-needs-options') === 'true') {
      this.openQuickView(btn.getAttribute('data-handle'), btn);
      return;
    }
    this.setBtn(btn, 'busy', mode === 'buy' ? this.s.redirecting : this.s.adding);
    try {
      await this.addItem(btn.getAttribute('data-variant-id'), 1);
      if (mode === 'buy') { await this.goToCheckout(btn); return; }
      this.setBtn(btn, 'done', this.s.added);
      await this.afterAdd(btn);
      var self = this;
      setTimeout(function () { self.setBtn(btn, 'idle'); }, 1600);
    } catch (err) {
      this.setBtn(btn, 'idle');
      this.toast(this.errMsg(err), 'error');
    }
  };

  Collection.prototype.afterAdd = async function (trigger) {
    var cart;
    try { cart = await this.getCart(); } catch (_) { cart = null; }
    if (cart) { this.renderCart(cart); this.updateCount(cart); }
    if (this.cfg.cartDrawer && this.panel('cart')) this.openPanel('cart', trigger);
    else this.toast(this.s.addedToast);
  };

  Collection.prototype.openCart = async function (trigger) {
    if (!this.panel('cart')) return;
    this.openPanel('cart', trigger);
    try { var cart = await this.getCart(); this.renderCart(cart); this.updateCount(cart); }
    catch (err) { this.toast(this.errMsg(err), 'error'); }
  };

  Collection.prototype.renderCart = function (cart) {
    var list = qs('[data-tc-cart-items]', this.root);
    if (!list) return;
    var s = this.s, self = this;
    qsa('[data-tc-cart-count]', this.root).forEach(function (el) { el.textContent = cart.item_count; });
    var sub = qs('[data-tc-cart-subtotal]', this.root);
    if (sub) sub.innerHTML = this.money(cart.items_subtotal_price);
    var foot = qs('[data-tc-cart-foot]', this.root);
    if (foot) foot.hidden = cart.item_count === 0;

    if (!cart.items || !cart.items.length) {
      list.innerHTML = '<div class="tc-cart-empty"><p>' + esc(s.cartEmpty) + '</p><button type="button" class="tc-btn tc-btn--primary" data-tc-close>' + esc(s.continueShopping) + '</button></div>';
    } else {
      list.innerHTML = '<ul class="tc-lines" role="list">' + cart.items.map(function (i) { return self.lineHtml(i); }).join('') + '</ul>';
    }
    if (this.openName === 'cart') {
      var a = document.activeElement;
      if (!a || a === document.body || !this.panel('cart').contains(a)) {
        var f = qs('[data-tc-autofocus]', this.panel('cart'));
        if (f) f.focus({ preventScroll: true });
      }
    }
  };

  Collection.prototype.lineHtml = function (item) {
    var s = this.s;
    var img = item.image ? this.sized(item.image, 200) : '';
    var variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
    var key = esc(item.key);
    var title = esc(item.product_title);
    var discounted = item.original_line_price > item.final_line_price;
    return '' +
      '<li class="tc-line" data-key="' + key + '" data-qty="' + item.quantity + '">' +
        '<a class="tc-line__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '') +
        '</a>' +
        '<div class="tc-line__info">' +
          '<a class="tc-line__title" href="' + esc(item.url) + '">' + title + '</a>' +
          (variant ? '<p class="tc-line__variant">' + esc(variant) + '</p>' : '') +
          '<p class="tc-line__price">' + this.money(item.final_line_price) + (discounted ? '<s>' + this.money(item.original_line_price) + '</s>' : '') + '</p>' +
          '<div class="tc-qty" role="group" aria-label="' + esc(s.quantity) + ', ' + title + '">' +
            '<button type="button" data-tc-line-step="-1" data-key="' + key + '" aria-label="' + esc(s.decrease) + '">' + ICON_MINUS + '</button>' +
            '<span class="tc-qty__val" aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-tc-line-step="1" data-key="' + key + '" aria-label="' + esc(s.increase) + '">' + ICON_PLUS + '</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="tc-line__remove" data-tc-remove data-key="' + key + '" aria-label="' + esc(s.remove) + ' ' + title + '">' + ICON_TRASH + '</button>' +
      '</li>';
  };

  Collection.prototype.stepLine = function (btn) {
    var line = btn.closest('.tc-line');
    if (!line) return;
    var qty = Number(line.getAttribute('data-qty')) + Number(btn.getAttribute('data-tc-line-step'));
    this.changeLine(line.getAttribute('data-key'), Math.max(0, qty));
  };

  Collection.prototype.changeLine = async function (key, quantity) {
    var line = qsa('.tc-line', this.root).filter(function (l) { return l.getAttribute('data-key') === key; })[0];
    if (line) line.classList.add('is-busy');
    try {
      var cart = await this.request(this.cfg.routes.cartChange + '.js', { id: key, quantity: quantity });
      this.renderCart(cart);
      this.updateCount(cart);
    } catch (err) {
      this.toast(this.errMsg(err), 'error');
      try { var fresh = await this.getCart(); this.renderCart(fresh); this.updateCount(fresh); }
      catch (_) { if (line) line.classList.remove('is-busy'); }
    }
  };

  Collection.prototype.updateCount = function (cart) {
    var n = cart.item_count;
    qsa('[data-tc-cart-count]', this.root).forEach(function (el) { el.textContent = n; });
    if (this.cfg.cartCountSelector) {
      try { qsa(this.cfg.cartCountSelector).forEach(function (el) { el.textContent = n; }); } catch (_) {}
    }
    // Let the theme header (Horizon listens for a cart update event) and apps refresh.
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'tanhood-collection', data: { source: 'tanhood-collection', itemCount: n } }
    }));
  };

  /* ---------------------------- Checkout (Shopflo) ----------------------------
     Mirrors naGoToCheckout() from the theme's working "New Arrivals Grid" section:
       1. window.TanhoodCheckoutHandler() (optional override)
       2. Shopflo's JS object, using the same guarded method checks as that section
       3. Theme setting "Existing Shopflo checkout button selector"
       4. The THEME'S native checkout trigger (Horizon cart drawer etc.) — the element
          Shopflo's script is listening on. Buttons inside this section are skipped.
       5. /checkout
  ------------------------------------------------------------------------------ */
  var NATIVE_CHECKOUT = [
    '[data-shopflo-checkout]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    '[data-checkout-button]',
    'a[href="/checkout"]'
  ];

  Collection.prototype.findNativeCheckout = function () {
    var root = this.root;
    for (var i = 0; i < NATIVE_CHECKOUT.length; i++) {
      var found = qsa(NATIVE_CHECKOUT[i]).filter(function (el) { return !root.contains(el); })[0];
      if (found) return found;
    }
    return null;
  };

  Collection.prototype.goToCheckout = async function (btn) {
    var self = this, left = false, done = false;
    var onLeave = function () { left = true; };
    window.addEventListener('beforeunload', onLeave, { once: true });
    window.addEventListener('pagehide', onLeave, { once: true });

    // Close our own drawer/modal so it can't sit on top of Shopflo's checkout window.
    if (this.openName) this.closePanel(false);

    // 1) Optional explicit override
    if (typeof window.TanhoodCheckoutHandler === 'function') {
      try { await window.TanhoodCheckoutHandler(); done = true; } catch (err) { console.warn('[Tanhood] TanhoodCheckoutHandler failed', err); }
    }

    // 2) Shopflo JS object — same checks as the working New Arrivals section
    if (!done) {
      try {
        var flo = window.Shopflo || window.shopflo || window.SHOPFLO;
        if (flo) {
          ['checkout', 'openCheckout', 'redirectToCheckout', 'goToCheckout'].some(function (m) {
            if (typeof flo[m] === 'function') { flo[m](); done = true; return true; }
            return false;
          });
        }
      } catch (_) { done = false; }
    }

    // 3) Selector from theme settings
    if (!done && this.cfg.checkoutSelector) {
      var custom = null;
      try { custom = document.querySelector(this.cfg.checkoutSelector); } catch (_) { custom = null; }
      if (custom && !this.root.contains(custom)) { custom.click(); done = true; }
    }

    // 4) The theme's native checkout trigger (what Shopflo listens on)
    if (!done) {
      var native = this.findNativeCheckout();
      if (native) { native.click(); done = true; }
    }

    // 5) Last resort — same as the New Arrivals section
    if (!done) { window.location.href = '/checkout'; return; }

    // If the customer closes Shopflo and stays on the page, unstick the button.
    if (btn) {
      setTimeout(function () { if (!left) self.setBtn(btn, 'idle'); }, 4000);
    }
  };

  /* ---------------------------- Quick view / variant picker ---------------------------- */
  Collection.prototype.fetchProduct = async function (handle) {
    var key = 'product:' + handle;
    if (this.cache.has(key)) return this.cache.get(key);
    var root = String(this.cfg.routes.root || '/').replace(/\/$/, '');
    var res = await fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('product');
    var data = await res.json();
    this.cache.set(key, data);
    return data;
  };

  Collection.prototype.normalizeOptions = function (product) {
    return (product.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var vals = [];
        product.variants.forEach(function (v) { var x = v.options[i]; if (vals.indexOf(x) === -1) vals.push(x); });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values || [] };
    });
  };

  Collection.prototype.openQuickView = async function (handle, trigger) {
    var p = this.panel('quickview');
    if (!p || !handle) return;
    var body = qs('[data-tc-qv-body]', p);
    body.innerHTML = '<div class="tc-loader"><span class="tc-spinner" aria-hidden="true"></span></div>';
    this.qvTrigger = trigger;
    this.openPanel('quickview', trigger);
    try {
      var product = await this.fetchProduct(handle);
      var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      this.qv = { product: product, variant: first, qty: 1, options: this.normalizeOptions(product) };
      body.innerHTML = this.qvHtml();
      this.updateQv();
    } catch (_) {
      this.closePanel();
      this.toast(this.s.productError, 'error');
    }
  };

  Collection.prototype.qvHtml = function () {
    var s = this.s, qv = this.qv, product = qv.product, self = this;
    var single = product.variants.length === 1;
    var opts = single ? '' : qv.options.map(function (o, i) {
      return '<fieldset class="tc-qv__option"><legend>' + esc(o.name) + ': <span data-tc-qv-selected="' + i + '"></span></legend><div class="tc-qv__values">' +
        o.values.map(function (val) {
          var checked = qv.variant && qv.variant.options[i] === val ? ' checked' : '';
          return '<label class="tc-chip"><input type="radio" class="tc-sr" name="tc-qv-' + esc(self.cfg.sectionId) + '-' + i + '" value="' + esc(val) + '" data-tc-qv-option="' + i + '"' + checked + '><span>' + esc(val) + '</span></label>';
        }).join('') + '</div></fieldset>';
    }).join('');
    var url = product.url || ('/products/' + product.handle);
    return '' +
      '<div class="tc-qv">' +
        '<div class="tc-qv__media"><img data-tc-qv-img alt="' + esc(product.title) + '" src="' + esc(this.sized(product.featured_image, 900)) + '"></div>' +
        '<div class="tc-qv__info">' +
          '<h2 class="tc-display tc-qv__title" id="tc-qv-title-' + esc(this.cfg.sectionId) + '">' + esc(product.title) + '</h2>' +
          '<div class="tc-qv__price" data-tc-qv-price></div>' +
          opts +
          '<div class="tc-qty" role="group" aria-label="' + esc(s.quantity) + '">' +
            '<button type="button" data-tc-qv-step="-1" aria-label="' + esc(s.decrease) + '">' + ICON_MINUS + '</button>' +
            '<span class="tc-qty__val" data-tc-qv-qty aria-live="polite">1</span>' +
            '<button type="button" data-tc-qv-step="1" aria-label="' + esc(s.increase) + '">' + ICON_PLUS + '</button>' +
          '</div>' +
          '<p class="tc-qv__status" data-tc-qv-status aria-live="polite"></p>' +
          '<div class="tc-qv__actions"' + (this.cfg.showBuyNow ? '' : ' style="grid-template-columns:1fr"') + '>' +
            '<button type="button" class="tc-btn tc-btn--primary" data-tc-qv-add>' + esc(s.addToCart) + '</button>' +
            (this.cfg.showBuyNow ? '<button type="button" class="tc-btn tc-btn--outline" data-tc-qv-buy>' + esc(s.buyNow) + '</button>' : '') +
          '</div>' +
          '<a class="tc-qv__more" href="' + esc(url) + '">' + esc(s.viewDetails) + '</a>' +
        '</div>' +
      '</div>';
  };

  Collection.prototype.selectedOptions = function () {
    var p = this.panel('quickview');
    return this.qv.options.map(function (_, i) {
      var c = qs('input[data-tc-qv-option="' + i + '"]:checked', p);
      return c ? c.value : null;
    });
  };

  Collection.prototype.onQvOption = function () {
    if (!this.qv) return;
    var sel = this.selectedOptions();
    this.qv.variant = this.qv.product.variants.filter(function (v) {
      return sel.every(function (x, k) { return v.options[k] === x; });
    })[0] || null;
    this.updateQv();
  };

  Collection.prototype.updateQv = function () {
    var p = this.panel('quickview'), qv = this.qv, s = this.s;
    if (!qv || !p) return;
    var product = qv.product, v = qv.variant;

    qsa('[data-tc-qv-selected]', p).forEach(function (el) {
      var c = qs('input[data-tc-qv-option="' + el.getAttribute('data-tc-qv-selected') + '"]:checked', p);
      el.textContent = c ? c.value : '';
    });

    if (product.variants.length > 1) {
      var sel = this.selectedOptions();
      qsa('input[data-tc-qv-option]', p).forEach(function (input) {
        var i = Number(input.getAttribute('data-tc-qv-option'));
        var trial = sel.slice(); trial[i] = input.value;
        var ok = product.variants.some(function (x) {
          return x.available && trial.every(function (val, k) { return val === null || x.options[k] === val; });
        });
        input.closest('.tc-chip').classList.toggle('is-unavailable', !ok);
      });
    }

    var priceEl = qs('[data-tc-qv-price]', p);
    if (v) {
      var html = '<span>' + this.money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        html += '<s><span class="tc-sr">' + esc(s.regularPrice) + ' </span>' + this.money(v.compare_at_price) + '</s><span class="tc-save">' + esc(s.save) + ' ' + pct + '%</span>';
      }
      priceEl.innerHTML = html;
    } else {
      priceEl.innerHTML = '<span>' + esc(s.unavailable) + '</span>';
    }

    var img = qs('[data-tc-qv-img]', p);
    var src = (v && v.featured_image && v.featured_image.src) || product.featured_image;
    if (img && src) img.src = this.sized(src, 900);

    var qtyEl = qs('[data-tc-qv-qty]', p);
    if (qtyEl) qtyEl.textContent = qv.qty;

    var can = !!(v && v.available);
    var status = qs('[data-tc-qv-status]', p);
    if (status) status.textContent = !v ? s.unavailable : (!v.available ? s.soldOut : '');
    [qs('[data-tc-qv-add]', p), qs('[data-tc-qv-buy]', p)].forEach(function (b) {
      if (!b || b.getAttribute('aria-busy') === 'true') return;
      b.disabled = !can;
      if (!b.hasAttribute('data-label')) b.setAttribute('data-label', b.textContent.trim());
      b.textContent = can ? b.getAttribute('data-label') : (!v ? s.unavailable : s.soldOut);
    });
  };

  Collection.prototype.stepQv = function (d) {
    if (!this.qv) return;
    this.qv.qty = Math.max(1, Math.min(99, this.qv.qty + d));
    var el = qs('[data-tc-qv-qty]', this.panel('quickview'));
    if (el) el.textContent = this.qv.qty;
  };

  Collection.prototype.qvSubmit = async function (mode, btn) {
    var v = this.qv && this.qv.variant;
    if (!v || !v.available || btn.getAttribute('aria-busy') === 'true') return;
    this.setBtn(btn, 'busy', mode === 'buy' ? this.s.redirecting : this.s.adding);
    try {
      await this.addItem(v.id, this.qv.qty);
      if (mode === 'buy') { await this.goToCheckout(btn); return; }
      this.setBtn(btn, 'idle');
      var trigger = this.qvTrigger;
      this.closePanel(false);
      this.lastFocus = trigger;
      await this.afterAdd(trigger);
    } catch (err) {
      this.setBtn(btn, 'idle');
      this.toast(this.errMsg(err), 'error');
    }
  };

  /* ---------------------------- Wishlist (UI only) ---------------------------- */
  Collection.prototype.toggleWishlist = function (btn) {
    var on = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.dispatchEvent(new CustomEvent('tanhood:wishlist:toggle', {
      bubbles: true,
      detail: { productId: btn.getAttribute('data-product-id'), handle: btn.getAttribute('data-handle'), active: on }
    }));
  };

  /* ---------------------------- Toast ---------------------------- */
  Collection.prototype.toast = function (message, type) {
    var el = this.toastEl;
    if (!el) return;
    el.textContent = message;
    el.setAttribute('data-type', type || 'info');
    el.classList.add('is-visible');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4200);
  };

  /* ---------------------------- Boot ---------------------------- */
  var instances = new Map();
  var init = function (scope) {
    qsa('[data-tc-root]', scope || document).forEach(function (root) {
      if (instances.has(root)) return;
      try { instances.set(root, new Collection(root)); } catch (e) { console.error('[Tanhood collection]', e); }
    });
  };
  window.TanhoodCollection = { init: init, instances: instances };

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    qsa('[data-tc-root]', e.target).forEach(function (r) {
      var inst = instances.get(r);
      if (inst) { inst.destroy(); instances.delete(r); }
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.TanhoodGridCart) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var visible = function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); };
  var esc = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var ICON = {
    close: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5v14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linejoin="round"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13 2 4 14h7l-1 8 9-12h-7z" fill="currentColor"/></svg>',
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="7" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="17" cy="17" r="1.8" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>',
    returns: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 13.7-5.6L20 8.7M20 4v4.7h-4.7M20 12a8 8 0 0 1-13.7 5.6L4 15.3M4 20v-4.7h4.7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ------------------------------ Config ------------------------------ */
  var DEFAULTS = {
    moneyFormat: '{{amount}}',
    checkoutLabel: 'Checkout with Shopflo',
    cartNote: 'Tax included. Shipping calculated at checkout.',
    shopfloSelector: '',
    cartUrl: '/cart',
    cartAddUrl: '/cart/add',
    cartChangeUrl: '/cart/change',
    colorPrimary: '#5B3218',
    colorAccent: '#D2B67A',
    colorText: '#2A1C13'
  };
  var config = function () {
    var out = {}, k;
    for (k in DEFAULTS) out[k] = DEFAULTS[k];
    var node = qs('[data-scg] [data-scg-config]');
    if (node) {
      try {
        var parsed = JSON.parse(node.textContent);
        for (k in parsed) if (parsed[k] !== null && parsed[k] !== '') out[k] = parsed[k];
        if (parsed.cartNote === '') out.cartNote = '';
      } catch (_) {}
    }
    return out;
  };

  var money = function (cents) {
    var fmt = config().moneyFormat || '{{amount}}';
    var value = Number(cents) || 0;
    var num = function (precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', '');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return num(2, ' ', '.');
        default: return num(2, ',', '.');
      }
    });
  };

  var sized = function (src, width) {
    if (!src) return '';
    try { var u = new URL(src, location.href); u.searchParams.set('width', width); return u.href; } catch (_) { return src; }
  };

  /* ------------------------------ Cart API ------------------------------ */
  var request = async function (url, body) {
    var res;
    try {
      res = await fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      });
    } catch (_) {
      throw new Error("We couldn't reach the store. Check your connection and try again.");
    }
    var data = null;
    try { data = await res.json(); } catch (_) {}
    if (!res.ok) {
      var msg = data && (typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : '');
      throw new Error(msg && msg.length < 200 ? msg : 'Sorry, this product is currently unavailable.');
    }
    return data;
  };
  var getCart = function () { return request(config().cartUrl + '.js'); };

  // Tell the theme header / native cart and apps that the cart changed.
  var notifyTheme = function (cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (cart) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'tanhood-grid', data: { source: 'tanhood-grid', itemCount: cart.item_count } }
      }));
    }
  };

  /* ------------------------------ Toast ------------------------------ */
  var toastEl = null, toastTimer = null;
  var toast = function (message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tcd-toast';
      toastEl.setAttribute('role', 'alert');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4200);
  };

  /* ------------------------------ Checkout (Shopflo) ------------------------------
     Same cascade as the working New Arrivals section:
       1. window.TanhoodCheckoutHandler() (optional override)
       2. Shopflo JS object, guarded method checks
       3. "Existing Shopflo checkout button selector" section setting
       4. The theme's native checkout trigger — Shopflo listens for clicks on it.
          IMPORTANT: no visibility check. The theme's cart-drawer checkout button
          is hidden while that drawer is closed; the old `offsetParent !== null`
          check skipped it and sent customers to plain /checkout, bypassing Shopflo.
       5. /checkout
  --------------------------------------------------------------------------------- */
  var NATIVE_CHECKOUT = [
    '[data-shopflo-checkout]',
    'form[action*="/cart"] button[name="checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    '[data-checkout-button]',
    'a[href="/checkout"]'
  ];

  var isOwnButton = function (el) {
    return (Drawer.el && Drawer.el.contains(el)) || el.hasAttribute('data-tc-checkout-btn') || el.hasAttribute('data-tcd-checkout');
  };

  var goToCheckout = async function (onStay) {
    var left = false, done = false;
    var onLeave = function () { left = true; };
    window.addEventListener('beforeunload', onLeave, { once: true });
    window.addEventListener('pagehide', onLeave, { once: true });

    if (Drawer.isOpen) Drawer.close(false);

    if (typeof window.TanhoodCheckoutHandler === 'function') {
      try { await window.TanhoodCheckoutHandler(); done = true; } catch (err) { console.warn('[Tanhood] TanhoodCheckoutHandler failed', err); }
    }

    if (!done) {
      try {
        var flo = window.Shopflo || window.shopflo || window.SHOPFLO;
        if (flo) {
          ['checkout', 'openCheckout', 'redirectToCheckout', 'goToCheckout'].some(function (m) {
            if (typeof flo[m] === 'function') { flo[m](); done = true; return true; }
            return false;
          });
        }
      } catch (_) { done = false; }
    }

    var sel = config().shopfloSelector;
    if (!done && sel) {
      var custom = null;
      try { custom = document.querySelector(sel); } catch (_) { custom = null; }
      if (custom && !isOwnButton(custom)) { custom.click(); done = true; }
    }

    if (!done) {
      for (var i = 0; i < NATIVE_CHECKOUT.length && !done; i++) {
        var native = qsa(NATIVE_CHECKOUT[i]).filter(function (el) { return !isOwnButton(el); })[0];
        if (native) { native.click(); done = true; }
      }
    }

    if (!done) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = root + 'checkout';
      return;
    }

    if (typeof onStay === 'function') {
      setTimeout(function () { if (!left) onStay(); }, 4000);
    }
  };

  /* ------------------------------ Drawer ------------------------------ */
  var Drawer = {
    el: null,
    overlay: null,
    isOpen: false,
    lastFocus: null,

    ensure: function () {
      if (this.el) return;
      var c = config(), self = this;

      this.overlay = document.createElement('div');
      this.overlay.className = 'tcd-overlay';
      this.overlay.hidden = true;

      var d = document.createElement('aside');
      d.className = 'tcd';
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      d.setAttribute('aria-labelledby', 'tcd-title');
      d.setAttribute('tabindex', '-1');
      d.style.setProperty('--tcd-primary', c.colorPrimary);
      d.style.setProperty('--tcd-accent', c.colorAccent);
      d.style.setProperty('--tcd-text', c.colorText);
      d.innerHTML =
        '<header class="tcd__head">' +
          '<h2 class="tcd__title" id="tcd-title">Shopping cart (<span data-tcd-count>0</span>)</h2>' +
          '<button type="button" class="tcd__icon-btn" data-tcd-close aria-label="Close cart">' + ICON.close + '</button>' +
        '</header>' +
        '<div class="tcd__body" data-tcd-items><div class="tcd__loader"><span class="tcd__spinner" aria-hidden="true"></span></div></div>' +
        '<footer class="tcd__foot" data-tcd-foot hidden>' +
          '<div class="tcd__subtotal"><span>Subtotal</span><span data-tcd-subtotal></span></div>' +
          (c.cartNote ? '<p class="tcd__note">' + esc(c.cartNote) + '</p>' : '') +
          '<a href="' + esc(c.cartUrl) + '" class="tcd__btn tcd__btn--primary">View cart</a>' +
          '<button type="button" class="tcd__btn tcd__btn--gold" data-tcd-checkout>' + ICON.bolt + esc(c.checkoutLabel) + '</button>' +
          '<ul class="tcd__trust" role="list">' +
            '<li>' + ICON.lock + 'Secure payments</li>' +
            '<li>' + ICON.truck + 'Free shipping</li>' +
            '<li>' + ICON.returns + 'Easy returns</li>' +
          '</ul>' +
        '</footer>';

      document.body.appendChild(this.overlay);
      document.body.appendChild(d);
      this.el = d;

      this.overlay.addEventListener('click', function () { self.close(); });
      d.addEventListener('click', function (e) {
        var t = e.target, el;
        if ((el = t.closest('[data-tcd-close]'))) { e.preventDefault(); self.close(); return; }
        if ((el = t.closest('[data-tcd-checkout]'))) {
          e.preventDefault();
          el.setAttribute('aria-busy', 'true');
          goToCheckout(function () { el.removeAttribute('aria-busy'); });
          return;
        }
        if ((el = t.closest('[data-tcd-step]'))) {
          e.preventDefault();
          var line = el.closest('[data-tcd-line]');
          var qty = Number(line.getAttribute('data-qty')) + Number(el.getAttribute('data-tcd-step'));
          self.change(line.getAttribute('data-key'), Math.max(0, qty));
          return;
        }
        if ((el = t.closest('[data-tcd-remove]'))) { e.preventDefault(); self.change(el.getAttribute('data-key'), 0); }
      });

      document.addEventListener('keydown', function (e) {
        if (!self.isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
        if (e.key !== 'Tab') return;
        var items = qsa(FOCUSABLE, d).filter(visible);
        if (!items.length) { e.preventDefault(); d.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && (document.activeElement === first || !d.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    },

    open: function (trigger) {
      this.ensure();
      if (this.isOpen) return;
      this.lastFocus = trigger || document.activeElement;
      this.isOpen = true;
      var ov = this.overlay, d = this.el;
      ov.hidden = false;
      requestAnimationFrame(function () { ov.classList.add('is-visible'); });
      d.classList.add('is-open');
      document.documentElement.classList.add('tcd-lock');
      requestAnimationFrame(function () { var f = qs('[data-tcd-close]', d); if (f) f.focus({ preventScroll: true }); });
    },

    close: function (restoreFocus) {
      if (!this.el || !this.isOpen) return;
      this.isOpen = false;
      var ov = this.overlay, self = this;
      this.el.classList.remove('is-open');
      ov.classList.remove('is-visible');
      setTimeout(function () { if (!self.isOpen) ov.hidden = true; }, 260);
      document.documentElement.classList.remove('tcd-lock');
      if (restoreFocus !== false && this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus({ preventScroll: true });
      this.lastFocus = null;
    },

    refresh: async function () {
      this.ensure();
      var cart = await getCart();
      this.render(cart);
      return cart;
    },

    render: function (cart) {
      this.ensure();
      var d = this.el;
      qs('[data-tcd-count]', d).textContent = cart.item_count;
      qs('[data-tcd-subtotal]', d).innerHTML = money(cart.items_subtotal_price);
      qs('[data-tcd-foot]', d).hidden = cart.item_count === 0;
      var list = qs('[data-tcd-items]', d);
      if (!cart.items || !cart.items.length) {
        list.innerHTML = '<div class="tcd__empty"><p>Your cart is empty.</p><button type="button" class="tcd__btn tcd__btn--primary" data-tcd-close>Continue shopping</button></div>';
      } else {
        list.innerHTML = '<ul class="tcd__lines" role="list">' + cart.items.map(this.lineHtml).join('') + '</ul>';
      }
      if (this.isOpen && !d.contains(document.activeElement)) {
        var f = qs('[data-tcd-close]', d);
        if (f) f.focus({ preventScroll: true });
      }
    },

    lineHtml: function (item) {
      var key = esc(item.key), title = esc(item.product_title);
      var img = item.image ? sized(item.image, 200) : '';
      var variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
      var discounted = item.original_line_price > item.final_line_price;
      return '' +
        '<li class="tcd__line" data-tcd-line data-key="' + key + '" data-qty="' + item.quantity + '">' +
          '<a class="tcd__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '') +
          '</a>' +
          '<div class="tcd__info">' +
            '<a class="tcd__line-title" href="' + esc(item.url) + '">' + title + '</a>' +
            (variant ? '<p class="tcd__variant">' + esc(variant) + '</p>' : '') +
            '<p class="tcd__price">' + money(item.final_line_price) + (discounted ? '<s>' + money(item.original_line_price) + '</s>' : '') + '</p>' +
            '<div class="tcd__qty" role="group" aria-label="Quantity, ' + title + '">' +
              '<button type="button" data-tcd-step="-1" aria-label="Decrease quantity">' + ICON.minus + '</button>' +
              '<span class="tcd__qty-val" aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" data-tcd-step="1" aria-label="Increase quantity">' + ICON.plus + '</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="tcd__remove" data-tcd-remove data-key="' + key + '" aria-label="Remove ' + title + '">' + ICON.trash + '</button>' +
        '</li>';
    },

    change: async function (key, quantity) {
      var line = qsa('[data-tcd-line]', this.el).filter(function (l) { return l.getAttribute('data-key') === key; })[0];
      if (line) line.classList.add('is-busy');
      try {
        var cart = await request(config().cartChangeUrl + '.js', { id: key, quantity: quantity });
        this.render(cart);
        notifyTheme(cart);
      } catch (err) {
        toast(err.message);
        try { var fresh = await getCart(); this.render(fresh); } catch (_) { if (line) line.classList.remove('is-busy'); }
      }
    }
  };

  /* ------------------------------ Card buttons ------------------------------ */
  var handleCta = async function (btn) {
    if (btn.disabled) return;
    var variantId = Number(btn.getAttribute('data-default-variant-id'));
    if (!variantId) return;

    var card = btn.closest('.na-card');
    var isBuyNow = btn.getAttribute('data-action') === 'buynow';
    var isIcon = btn.classList.contains('na-icon-btn');
    var related = card ? qsa('.na-addcart-btn, .na-buynow-btn, .na-quick-add', card) : [btn];
    var original = btn.textContent;

    var restore = function () {
      related.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
      if (!isIcon) btn.textContent = original;
    };

    related.forEach(function (b) { b.disabled = true; });
    btn.setAttribute('aria-busy', 'true');
    if (!isIcon) btn.textContent = isBuyNow ? 'Processing…' : 'Adding…';

    try {
      await request(config().cartAddUrl + '.js', { items: [{ id: variantId, quantity: 1 }] });

      if (isBuyNow) {
        notifyTheme(null);
        await goToCheckout(restore);
        return;
      }

      var cart = await Drawer.refresh();
      notifyTheme(cart);
      Drawer.open(btn);

      related.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
      if (isIcon) {
        btn.classList.add('na-added');
        setTimeout(function () { btn.classList.remove('na-added'); }, 1500);
      } else {
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = original; }, 1500);
      }
    } catch (err) {
      console.error((isBuyNow ? 'Buy now' : 'Add to cart') + ' failed', err);
      restore();
      toast(err && err.message ? err.message : 'Sorry, this product is currently unavailable.');
    }
  };

  // Wishlist heart — UI toggle only (same behaviour as the collection page card)
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-scg] [data-na-wishlist]');
    if (!h) return;
    e.preventDefault();
    var on = h.getAttribute('aria-pressed') !== 'true';
    h.setAttribute('aria-pressed', on ? 'true' : 'false');
    h.dispatchEvent(new CustomEvent('tanhood:wishlist:toggle', {
      bubbles: true,
      detail: { productId: h.getAttribute('data-product-id'), handle: h.getAttribute('data-handle'), active: on }
    }));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-scg] .na-addcart-btn, [data-scg] .na-buynow-btn, [data-scg] .na-quick-add');
    if (!btn) return;
    e.preventDefault();
    handleCta(btn);
  });

  /* ------------------------------ Carousel + slider ------------------------------ */
  var initRoot = function (root) {
    if (root.hasAttribute('data-scg-ready')) return;
    root.setAttribute('data-scg-ready', '');

    qsa('.na-card-media', root).forEach(function (media) {
      var slides = qsa('.na-slide', media);
      var dots = qsa('.na-dot', media);
      if (slides.length < 2) return;
      var current = 0;
      var show = function (i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, idx) { s.classList.toggle('na-slide-active', idx === current); });
        dots.forEach(function (d, idx) { d.classList.toggle('na-dot-active', idx === current); });
      };
      var prev = qs('.na-arrow-prev', media);
      var next = qs('.na-arrow-next', media);
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); show(current - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); show(current + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function (e) { e.preventDefault(); show(parseInt(d.getAttribute('data-dot'), 10)); });
      });
    });

    var grid = qs('.na-grid-slider', root);
    if (grid) {
      var step = function () {
        var card = qs('.na-card', grid);
        return card ? card.getBoundingClientRect().width + 12 : 240;
      };
      var p = qs('.na-slider-prev', root), n = qs('.na-slider-next', root);
      if (p) p.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
  };

  var initAll = function (scope) { qsa('[data-scg]', scope || document).forEach(initRoot); };

  window.TanhoodGridCart = { drawer: Drawer, goToCheckout: goToCheckout, init: initAll };

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    qsa('[data-scg] [aria-busy="true"]').forEach(function (b) { b.removeAttribute('aria-busy'); });
    qsa('[data-scg] .na-addcart-btn, [data-scg] .na-buynow-btn, [data-scg] .na-quick-add').forEach(function (b) {
      var card = b.closest('.na-card');
      var out = card && qs('.na-stock-out', card);
      b.disabled = !!out;
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tan-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.TanhoodCollection) return;

  var MQ = window.matchMedia('(max-width: 989px)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  var qs = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var qsa = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var esc = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var debounce = function (fn, wait) {
    var t;
    return function () { var a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(null, a); }, wait); };
  };
  var visible = function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); };

  var ICON_MINUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M12 5v14" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var ICON_TRASH = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v6M14 11v6" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linejoin="round"/></svg>';

  function CartError(message) { this.name = 'CartError'; this.message = message; }
  CartError.prototype = Object.create(Error.prototype);

  function Collection(root) {
    this.root = root;
    this.cfg = JSON.parse(qs('[data-tc-config]', root).textContent);
    this.s = this.cfg.strings;
    this.form = qs('[data-tc-filter-form]', root);
    this.sortInput = qs('[data-tc-sort-input]', root);
    this.overlay = qs('[data-tc-overlay]', root);
    this.toastEl = qs('[data-tc-toast]', root);
    this.cache = new Map();
    this.life = new AbortController();
    this.fetchAbort = null;
    this.requestId = 0;
    this.openName = null;
    this.lastFocus = null;
    this.qv = null;
    this.qvTrigger = null;
    this.currentKey = location.pathname + location.search;
    this.submitSoon = debounce(this.applyFilters.bind(this), 650);
    this.bind();
    this.paintPrice();
  }

  Collection.prototype.bind = function () {
    var self = this;
    var sig = { signal: this.life.signal };
    this.root.addEventListener('click', function (e) { self.onClick(e); }, sig);
    this.root.addEventListener('change', function (e) { self.onChange(e); }, sig);
    this.root.addEventListener('input', function (e) { self.onInput(e); }, sig);
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.applyFilters(); }, sig);
    window.addEventListener('popstate', function () { self.onPopState(); }, sig);
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.resetButtons(); }, sig);
    document.addEventListener('keydown', function (e) { self.onKeydown(e); }, sig);
    document.addEventListener('click', function (e) { self.onDocClick(e); }, { signal: this.life.signal, capture: true });
    if (MQ.addEventListener) {
      MQ.addEventListener('change', function () {
        if (self.openName === 'filters' || self.openName === 'sort') self.closePanel(false);
      }, sig);
    }
  };

  Collection.prototype.destroy = function () { this.life.abort(); };

  /* ---------------------------- Events ---------------------------- */
  Collection.prototype.onClick = function (e) {
    var t = e.target, el;
    if (t.matches('[data-tc-overlay]')) { this.closePanel(); return; }
    if ((el = t.closest('[data-tc-checkout-btn]'))) { e.preventDefault(); this.goToCheckout(null); return; }
    if ((el = t.closest('[data-tc-more]'))) {
      e.preventDefault();
      var list = el.previousElementSibling;
      var open = el.getAttribute('aria-expanded') !== 'true';
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (list) list.classList.toggle('is-collapsed', !open);
      return;
    }
    if ((el = t.closest('[data-tc-clear]'))) { e.preventDefault(); this.clearAll(); return; }
    if ((el = t.closest('a[data-tc-link]'))) { e.preventDefault(); this.render(el.href, { scroll: el.hasAttribute('data-tc-scroll') }); return; }
    if ((el = t.closest('[data-tc-sort]'))) { e.preventDefault(); this.setSort(el.getAttribute('data-tc-sort')); return; }
    if ((el = t.closest('[data-tc-open]'))) {
      e.preventDefault();
      var name = el.getAttribute('data-tc-open');
      if (this.openName === name) this.closePanel(); else this.openPanel(name, el);
      return;
    }
    if ((el = t.closest('[data-tc-close]'))) { e.preventDefault(); this.closePanel(); return; }
    if ((el = t.closest('[data-tc-add]'))) { e.preventDefault(); this.cardAction(el, 'add'); return; }
    if ((el = t.closest('[data-tc-buy]'))) { e.preventDefault(); this.cardAction(el, 'buy'); return; }
    if ((el = t.closest('[data-tc-quickview]'))) { e.preventDefault(); this.openQuickView(el.getAttribute('data-handle'), el); return; }
    if ((el = t.closest('[data-tc-wishlist]'))) { e.preventDefault(); this.toggleWishlist(el); return; }
    if ((el = t.closest('[data-tc-line-step]'))) { e.preventDefault(); this.stepLine(el); return; }
    if ((el = t.closest('[data-tc-remove]'))) { e.preventDefault(); this.changeLine(el.getAttribute('data-key'), 0); return; }
    if ((el = t.closest('[data-tc-qv-step]'))) { e.preventDefault(); this.stepQv(Number(el.getAttribute('data-tc-qv-step'))); return; }
    if ((el = t.closest('[data-tc-qv-add]'))) { e.preventDefault(); this.qvSubmit('add', el); return; }
    if ((el = t.closest('[data-tc-qv-buy]'))) { e.preventDefault(); this.qvSubmit('buy', el); return; }
  };

  Collection.prototype.onDocClick = function (e) {
    var sel = this.cfg.headerCartSelector;
    if (this.cfg.cartDrawer && sel) {
      var hit = null;
      try { hit = e.target.closest(sel); } catch (_) { hit = null; }
      if (hit && !this.root.contains(hit)) {
        e.preventDefault();
        e.stopPropagation();
        this.openCart(hit);
        return;
      }
    }
    if (this.openName === 'sort' && !MQ.matches) {
      var wrap = qs('[data-tc-sort-wrap]', this.root);
      if (wrap && !wrap.contains(e.target)) this.closePanel(false);
    }
  };

  Collection.prototype.onChange = function (e) {
    var t = e.target;
    if (t.matches('[data-tc-qv-option]')) { this.onQvOption(); return; }
    if (!this.form || !this.form.contains(t)) return;
    this.applyFilters();
  };

  Collection.prototype.onInput = function (e) {
    var t = e.target;
    if (t.matches('[data-tc-range]')) { this.syncFromRange(t); return; }
    if (t.matches('[data-tc-price-input]')) { this.syncFromInput(t); this.submitSoon(); }
  };

  Collection.prototype.onKeydown = function (e) {
    if (!this.openName) return;
    if (e.key === 'Escape') { e.preventDefault(); this.closePanel(); return; }
    if (e.key !== 'Tab' || !this.isModal(this.openName)) return;
    var panel = this.panel(this.openName);
    if (!panel) return;
    var items = qsa(FOCUSABLE, panel).filter(visible);
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  Collection.prototype.onPopState = function () {
    var key = location.pathname + location.search;
    if (key === this.currentKey) return;
    this.render(location.href, { push: false });
  };

  /* ---------------------------- Filters / sort ---------------------------- */
  Collection.prototype.priceParts = function (el) {
    var wrap = el.closest('[data-tc-price]');
    return {
      wrap: wrap,
      max: Number(wrap.getAttribute('data-max')),
      rMin: qs('[data-tc-range="min"]', wrap),
      rMax: qs('[data-tc-range="max"]', wrap),
      iMin: qs('[data-tc-price-input="min"]', wrap),
      iMax: qs('[data-tc-price-input="max"]', wrap)
    };
  };

  Collection.prototype.syncFromRange = function (range) {
    var p = this.priceParts(range);
    if (Number(p.rMin.value) > Number(p.rMax.value)) {
      if (range === p.rMin) p.rMin.value = p.rMax.value; else p.rMax.value = p.rMin.value;
    }
    p.iMin.value = Number(p.rMin.value) > 0 ? p.rMin.value : '';
    p.iMax.value = Number(p.rMax.value) < p.max ? p.rMax.value : '';
    this.paintPrice(p.wrap);
  };

  Collection.prototype.syncFromInput = function (input) {
    var p = this.priceParts(input);
    var lo = p.iMin.value === '' ? 0 : Math.max(0, Math.min(p.max, Number(p.iMin.value) || 0));
    var hi = p.iMax.value === '' ? p.max : Math.max(0, Math.min(p.max, Number(p.iMax.value) || 0));
    p.rMin.value = lo;
    p.rMax.value = hi;
    this.paintPrice(p.wrap);
  };

  Collection.prototype.paintPrice = function (only) {
    (only ? [only] : qsa('[data-tc-price]', this.root)).forEach(function (wrap) {
      var max = Number(wrap.getAttribute('data-max')) || 1;
      var lo = Number(qs('[data-tc-range="min"]', wrap).value);
      var hi = Number(qs('[data-tc-range="max"]', wrap).value);
      var fill = qs('[data-tc-price-fill]', wrap);
      fill.style.left = (Math.min(lo, hi) / max) * 100 + '%';
      fill.style.right = (100 - (Math.max(lo, hi) / max) * 100) + '%';
    });
  };

  Collection.prototype.baseUrl = function () {
    var action = this.form ? this.form.getAttribute('action') : location.pathname;
    return new URL(action || location.pathname, location.origin);
  };

  Collection.prototype.buildFilterUrl = function () {
    var url = this.baseUrl();
    var params = new URLSearchParams();
    if (this.form) {
      var prices = {};
      qsa('[data-tc-price-input]', this.form).forEach(function (i) { prices[i.name] = i; });
      new FormData(this.form).forEach(function (value, key) {
        var v = String(value).trim();
        if (v === '') return;
        var priceInput = prices[key];
        if (priceInput) {
          var n = Number(v);
          var max = Number(priceInput.closest('[data-tc-price]').getAttribute('data-max'));
          if (!isFinite(n)) return;
          if (priceInput.getAttribute('data-tc-price-input') === 'min' && n <= 0) return;
          if (priceInput.getAttribute('data-tc-price-input') === 'max' && n >= max) return;
          v = String(Math.round(n));
        }
        params.append(key, v);
      });
    } else if (this.sortInput && this.sortInput.value) {
      params.set('sort_by', this.sortInput.value);
    }
    url.search = params.toString();
    return url;
  };

  Collection.prototype.applyFilters = function () { this.render(this.buildFilterUrl().href); };

  Collection.prototype.setSort = function (value) {
    if (this.sortInput) this.sortInput.value = value;
    this.closePanel(false);
    if (this.form) { this.applyFilters(); return; }
    var url = new URL(location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    this.render(url.href);
  };

  Collection.prototype.clearAll = function () {
    var url = this.baseUrl();
    if (this.sortInput && this.sortInput.value) url.searchParams.set('sort_by', this.sortInput.value);
    if (this.openName === 'filters') this.closePanel(false);
    this.render(url.href, { scroll: true });
  };

  /* ---------------------------- Section rendering ---------------------------- */
  Collection.prototype.render = async function (href, opts) {
    opts = opts || {};
    var target = new URL(href, location.origin);
    target.hash = '';
    var key = target.pathname + target.search;
    if (opts.push !== false && key === this.currentKey) return;

    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', this.cfg.sectionId);

    if (this.fetchAbort) this.fetchAbort.abort();
    this.fetchAbort = new AbortController();
    var id = ++this.requestId;
    this.setLoading(true);

    try {
      var html = this.cache.get(fetchUrl.href);
      if (!html) {
        var res = await fetch(fetchUrl.href, { signal: this.fetchAbort.signal, credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        html = await res.text();
        this.cache.set(fetchUrl.href, html);
      }
      if (id !== this.requestId) return;
      this.swap(html);
      this.currentKey = key;
      if (opts.push !== false) history.pushState({ tanhood: true }, '', key);
      if (opts.scroll) this.scrollToResults();
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      // Never leave the page broken — fall back to a normal page load of the same URL.
      window.location.assign(target.href);
    } finally {
      if (id === this.requestId) this.setLoading(false);
    }
  };

  Collection.prototype.swap = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-tc-root]', doc);
    if (!fresh) throw new Error('Section markup missing');
    var state = this.captureState();

    var pool = {};
    qsa('[data-tc-region]', fresh).forEach(function (el) {
      var n = el.getAttribute('data-tc-region');
      (pool[n] = pool[n] || []).push(el);
    });
    var seen = {};
    qsa('[data-tc-region]', this.root).forEach(function (el) {
      var n = el.getAttribute('data-tc-region');
      seen[n] = n in seen ? seen[n] + 1 : 0;
      var src = pool[n] && pool[n][seen[n]];
      if (src) el.innerHTML = src.innerHTML;
    });

    var freshSort = qs('[data-tc-sort-input]', fresh);
    if (freshSort && this.sortInput) this.sortInput.value = freshSort.value;

    this.restoreState(state);
    this.paintPrice();

    // Judge.me: if its badge script is loaded, let it re-process badges injected via AJAX.
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (_) {}
    }
    this.root.dispatchEvent(new CustomEvent('tanhood:collection:updated', { bubbles: true }));
  };

  Collection.prototype.captureState = function () {
    var open = {};
    qsa('details[data-tc-key]', this.root).forEach(function (d) { open[d.getAttribute('data-tc-key')] = d.open; });
    var a = document.activeElement;
    var focusId = a && a.id && this.root.contains(a) ? a.id : null;
    var sel = null;
    try { if (focusId && typeof a.selectionStart === 'number') sel = a.selectionStart; } catch (_) {}
    var scroller = qs('[data-tc-filter-scroll]', this.root);
    return { open: open, focusId: focusId, sel: sel, scroll: scroller ? scroller.scrollTop : 0 };
  };

  Collection.prototype.restoreState = function (st) {
    qsa('details[data-tc-key]', this.root).forEach(function (d) {
      var k = d.getAttribute('data-tc-key');
      if (k in st.open) d.open = st.open[k];
    });
    var scroller = qs('[data-tc-filter-scroll]', this.root);
    if (scroller) scroller.scrollTop = st.scroll;
    if (st.focusId) {
      var el = document.getElementById(st.focusId);
      if (el) {
        el.focus({ preventScroll: true });
        try { if (st.sel !== null) el.setSelectionRange(st.sel, st.sel); } catch (_) {}
      }
    }
  };

  Collection.prototype.setLoading = function (on) {
    this.root.classList.toggle('tc--loading', on);
    var grid = qs('[data-tc-region="grid"]', this.root);
    if (grid) grid.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  Collection.prototype.scrollToResults = function () {
    var el = qs('[data-tc-results]', this.root);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: Math.max(0, top), behavior: REDUCED.matches ? 'auto' : 'smooth' });
  };

  /* ---------------------------- Panels ---------------------------- */
  Collection.prototype.panel = function (name) { return qs('[data-tc-panel="' + name + '"]', this.root); };
  Collection.prototype.isModal = function (name) { return name === 'cart' || name === 'quickview' || MQ.matches; };

  Collection.prototype.openPanel = function (name, trigger) {
    var p = this.panel(name);
    if (!p) return;
    if (this.openName && this.openName !== name) this.closePanel(false);
    if (!this.lastFocus || this.openName === null) this.lastFocus = trigger || document.activeElement;
    this.openName = name;
    p.classList.add('is-open');

    if (this.isModal(name)) {
      if (name === 'filters' || name === 'sort') { p.setAttribute('role', 'dialog'); p.setAttribute('aria-modal', 'true'); }
      if (this.overlay) {
        var ov = this.overlay;
        ov.hidden = false;
        requestAnimationFrame(function () { ov.classList.add('is-visible'); });
      }
      document.documentElement.classList.add('tc-scroll-lock');
    }
    qsa('[data-tc-open="' + name + '"]', this.root).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function () {
      var f = qs('[data-tc-autofocus]', p);
      if (!f || !visible(f)) f = qsa(FOCUSABLE, p).filter(visible)[0] || p;
      f.focus({ preventScroll: true });
    });
  };

  Collection.prototype.closePanel = function (restoreFocus) {
    var name = this.openName;
    if (!name) return;
    var p = this.panel(name);
    if (p) {
      p.classList.remove('is-open');
      if (name === 'filters' || name === 'sort') { p.removeAttribute('role'); p.removeAttribute('aria-modal'); }
    }
    qsa('[data-tc-open="' + name + '"]', this.root).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    this.openName = null;
    if (this.overlay) {
      var ov = this.overlay, self = this;
      ov.classList.remove('is-visible');
      setTimeout(function () { if (!self.openName) ov.hidden = true; }, 260);
    }
    document.documentElement.classList.remove('tc-scroll-lock');
    if (restoreFocus !== false && this.lastFocus && document.contains(this.lastFocus)) {
      this.lastFocus.focus({ preventScroll: true });
    }
    this.lastFocus = null;
  };

  /* ---------------------------- Money ---------------------------- */
  Collection.prototype.money = function (cents) {
    var fmt = this.cfg.moneyFormat || '{{amount}}';
    var value = Number(cents) || 0;
    var fmtNum = function (num, precision, thousands, decimal) {
      var parts = (num / 100).toFixed(precision).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNum(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(value, 0, ' ', '');
        case 'amount_with_space_separator': return fmtNum(value, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmtNum(value, 2, ' ', '.');
        default: return fmtNum(value, 2, ',', '.');
      }
    });
  };

  Collection.prototype.sized = function (src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', width);
      return u.href;
    } catch (_) { return src; }
  };

  /* ---------------------------- Cart API ---------------------------- */
  Collection.prototype.request = async function (url, body) {
    var res;
    try {
      res = await fetch(url, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      });
    } catch (_) {
      throw new CartError(this.s.network);
    }
    var data = null;
    try { data = await res.json(); } catch (_) {}
    if (!res.ok) {
      var msg = data && typeof data.description === 'string' ? data.description
        : data && typeof data.message === 'string' ? data.message : null;
      throw new CartError(msg && msg.length < 200 ? msg : this.s.error);
    }
    return data;
  };

  Collection.prototype.getCart = function () { return this.request(this.cfg.routes.cart + '.js'); };
  Collection.prototype.addItem = function (id, quantity) {
    var vid = Number(id);
    if (!vid) return Promise.reject(new CartError(this.s.error));
    return this.request(this.cfg.routes.cartAdd + '.js', { items: [{ id: vid, quantity: Math.max(1, quantity | 0) }] })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return data;
      });
  };

  Collection.prototype.errMsg = function (err) { return err instanceof CartError ? err.message : this.s.error; };

  Collection.prototype.setBtn = function (btn, state, label) {
    if (!btn) return;
    if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.textContent.trim());
    if (state === 'idle') {
      btn.textContent = btn.getAttribute('data-label');
      btn.removeAttribute('aria-busy');
      btn.disabled = btn.hasAttribute('data-soldout');
      return;
    }
    btn.textContent = label;
    btn.disabled = true;
    if (state === 'busy') btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  };

  Collection.prototype.resetButtons = function () {
    var self = this;
    qsa('[data-label]', this.root).forEach(function (b) { self.setBtn(b, 'idle'); });
  };

  Collection.prototype.cardAction = async function (btn, mode) {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    if (btn.getAttribute('data-needs-options') === 'true') {
      this.openQuickView(btn.getAttribute('data-handle'), btn);
      return;
    }
    this.setBtn(btn, 'busy', mode === 'buy' ? this.s.redirecting : this.s.adding);
    try {
      await this.addItem(btn.getAttribute('data-variant-id'), 1);
      if (mode === 'buy') { await this.goToCheckout(btn); return; }
      this.setBtn(btn, 'done', this.s.added);
      await this.afterAdd(btn);
      var self = this;
      setTimeout(function () { self.setBtn(btn, 'idle'); }, 1600);
    } catch (err) {
      this.setBtn(btn, 'idle');
      this.toast(this.errMsg(err), 'error');
    }
  };

  Collection.prototype.afterAdd = async function (trigger) {
    var cart;
    try { cart = await this.getCart(); } catch (_) { cart = null; }
    if (cart) { this.renderCart(cart); this.updateCount(cart); }
    if (this.cfg.cartDrawer && this.panel('cart')) this.openPanel('cart', trigger);
    else this.toast(this.s.addedToast);
  };

  Collection.prototype.openCart = async function (trigger) {
    if (!this.panel('cart')) return;
    this.openPanel('cart', trigger);
    try { var cart = await this.getCart(); this.renderCart(cart); this.updateCount(cart); }
    catch (err) { this.toast(this.errMsg(err), 'error'); }
  };

  Collection.prototype.renderCart = function (cart) {
    var list = qs('[data-tc-cart-items]', this.root);
    if (!list) return;
    var s = this.s, self = this;
    qsa('[data-tc-cart-count]', this.root).forEach(function (el) { el.textContent = cart.item_count; });
    var sub = qs('[data-tc-cart-subtotal]', this.root);
    if (sub) sub.innerHTML = this.money(cart.items_subtotal_price);
    var foot = qs('[data-tc-cart-foot]', this.root);
    if (foot) foot.hidden = cart.item_count === 0;

    if (!cart.items || !cart.items.length) {
      list.innerHTML = '<div class="tc-cart-empty"><p>' + esc(s.cartEmpty) + '</p><button type="button" class="tc-btn tc-btn--primary" data-tc-close>' + esc(s.continueShopping) + '</button></div>';
    } else {
      list.innerHTML = '<ul class="tc-lines" role="list">' + cart.items.map(function (i) { return self.lineHtml(i); }).join('') + '</ul>';
    }
    if (this.openName === 'cart') {
      var a = document.activeElement;
      if (!a || a === document.body || !this.panel('cart').contains(a)) {
        var f = qs('[data-tc-autofocus]', this.panel('cart'));
        if (f) f.focus({ preventScroll: true });
      }
    }
  };

  Collection.prototype.lineHtml = function (item) {
    var s = this.s;
    var img = item.image ? this.sized(item.image, 200) : '';
    var variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
    var key = esc(item.key);
    var title = esc(item.product_title);
    var discounted = item.original_line_price > item.final_line_price;
    return '' +
      '<li class="tc-line" data-key="' + key + '" data-qty="' + item.quantity + '">' +
        '<a class="tc-line__media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="84" height="84" loading="lazy">' : '') +
        '</a>' +
        '<div class="tc-line__info">' +
          '<a class="tc-line__title" href="' + esc(item.url) + '">' + title + '</a>' +
          (variant ? '<p class="tc-line__variant">' + esc(variant) + '</p>' : '') +
          '<p class="tc-line__price">' + this.money(item.final_line_price) + (discounted ? '<s>' + this.money(item.original_line_price) + '</s>' : '') + '</p>' +
          '<div class="tc-qty" role="group" aria-label="' + esc(s.quantity) + ', ' + title + '">' +
            '<button type="button" data-tc-line-step="-1" data-key="' + key + '" aria-label="' + esc(s.decrease) + '">' + ICON_MINUS + '</button>' +
            '<span class="tc-qty__val" aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-tc-line-step="1" data-key="' + key + '" aria-label="' + esc(s.increase) + '">' + ICON_PLUS + '</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="tc-line__remove" data-tc-remove data-key="' + key + '" aria-label="' + esc(s.remove) + ' ' + title + '">' + ICON_TRASH + '</button>' +
      '</li>';
  };

  Collection.prototype.stepLine = function (btn) {
    var line = btn.closest('.tc-line');
    if (!line) return;
    var qty = Number(line.getAttribute('data-qty')) + Number(btn.getAttribute('data-tc-line-step'));
    this.changeLine(line.getAttribute('data-key'), Math.max(0, qty));
  };

  Collection.prototype.changeLine = async function (key, quantity) {
    var line = qsa('.tc-line', this.root).filter(function (l) { return l.getAttribute('data-key') === key; })[0];
    if (line) line.classList.add('is-busy');
    try {
      var cart = await this.request(this.cfg.routes.cartChange + '.js', { id: key, quantity: quantity });
      this.renderCart(cart);
      this.updateCount(cart);
    } catch (err) {
      this.toast(this.errMsg(err), 'error');
      try { var fresh = await this.getCart(); this.renderCart(fresh); this.updateCount(fresh); }
      catch (_) { if (line) line.classList.remove('is-busy'); }
    }
  };

  Collection.prototype.updateCount = function (cart) {
    var n = cart.item_count;
    qsa('[data-tc-cart-count]', this.root).forEach(function (el) { el.textContent = n; });
    if (this.cfg.cartCountSelector) {
      try { qsa(this.cfg.cartCountSelector).forEach(function (el) { el.textContent = n; }); } catch (_) {}
    }
    // Let the theme header (Horizon listens for a cart update event) and apps refresh.
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'tanhood-collection', data: { source: 'tanhood-collection', itemCount: n } }
    }));
  };

  /* ---------------------------- Checkout (Shopflo) ----------------------------
     Mirrors naGoToCheckout() from the theme's working "New Arrivals Grid" section:
       1. window.TanhoodCheckoutHandler() (optional override)
       2. Shopflo's JS object, using the same guarded method checks as that section
       3. Theme setting "Existing Shopflo checkout button selector"
       4. The THEME'S native checkout trigger (Horizon cart drawer etc.) — the element
          Shopflo's script is listening on. Buttons inside this section are skipped.
       5. /checkout
  ------------------------------------------------------------------------------ */
  var NATIVE_CHECKOUT = [
    '[data-shopflo-checkout]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    '[data-checkout-button]',
    'a[href="/checkout"]'
  ];

  Collection.prototype.findNativeCheckout = function () {
    var root = this.root;
    for (var i = 0; i < NATIVE_CHECKOUT.length; i++) {
      var found = qsa(NATIVE_CHECKOUT[i]).filter(function (el) { return !root.contains(el); })[0];
      if (found) return found;
    }
    return null;
  };

  Collection.prototype.goToCheckout = async function (btn) {
    var self = this, left = false, done = false;
    var onLeave = function () { left = true; };
    window.addEventListener('beforeunload', onLeave, { once: true });
    window.addEventListener('pagehide', onLeave, { once: true });

    // Close our own drawer/modal so it can't sit on top of Shopflo's checkout window.
    if (this.openName) this.closePanel(false);

    // 1) Optional explicit override
    if (typeof window.TanhoodCheckoutHandler === 'function') {
      try { await window.TanhoodCheckoutHandler(); done = true; } catch (err) { console.warn('[Tanhood] TanhoodCheckoutHandler failed', err); }
    }

    // 2) Shopflo JS object — same checks as the working New Arrivals section
    if (!done) {
      try {
        var flo = window.Shopflo || window.shopflo || window.SHOPFLO;
        if (flo) {
          ['checkout', 'openCheckout', 'redirectToCheckout', 'goToCheckout'].some(function (m) {
            if (typeof flo[m] === 'function') { flo[m](); done = true; return true; }
            return false;
          });
        }
      } catch (_) { done = false; }
    }

    // 3) Selector from theme settings
    if (!done && this.cfg.checkoutSelector) {
      var custom = null;
      try { custom = document.querySelector(this.cfg.checkoutSelector); } catch (_) { custom = null; }
      if (custom && !this.root.contains(custom)) { custom.click(); done = true; }
    }

    // 4) The theme's native checkout trigger (what Shopflo listens on)
    if (!done) {
      var native = this.findNativeCheckout();
      if (native) { native.click(); done = true; }
    }

    // 5) Last resort — same as the New Arrivals section
    if (!done) { window.location.href = '/checkout'; return; }

    // If the customer closes Shopflo and stays on the page, unstick the button.
    if (btn) {
      setTimeout(function () { if (!left) self.setBtn(btn, 'idle'); }, 4000);
    }
  };

  /* ---------------------------- Quick view / variant picker ---------------------------- */
  Collection.prototype.fetchProduct = async function (handle) {
    var key = 'product:' + handle;
    if (this.cache.has(key)) return this.cache.get(key);
    var root = String(this.cfg.routes.root || '/').replace(/\/$/, '');
    var res = await fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('product');
    var data = await res.json();
    this.cache.set(key, data);
    return data;
  };

  Collection.prototype.normalizeOptions = function (product) {
    return (product.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var vals = [];
        product.variants.forEach(function (v) { var x = v.options[i]; if (vals.indexOf(x) === -1) vals.push(x); });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values || [] };
    });
  };

  Collection.prototype.openQuickView = async function (handle, trigger) {
    var p = this.panel('quickview');
    if (!p || !handle) return;
    var body = qs('[data-tc-qv-body]', p);
    body.innerHTML = '<div class="tc-loader"><span class="tc-spinner" aria-hidden="true"></span></div>';
    this.qvTrigger = trigger;
    this.openPanel('quickview', trigger);
    try {
      var product = await this.fetchProduct(handle);
      var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
      this.qv = { product: product, variant: first, qty: 1, options: this.normalizeOptions(product) };
      body.innerHTML = this.qvHtml();
      this.updateQv();
    } catch (_) {
      this.closePanel();
      this.toast(this.s.productError, 'error');
    }
  };

  Collection.prototype.qvHtml = function () {
    var s = this.s, qv = this.qv, product = qv.product, self = this;
    var single = product.variants.length === 1;
    var opts = single ? '' : qv.options.map(function (o, i) {
      return '<fieldset class="tc-qv__option"><legend>' + esc(o.name) + ': <span data-tc-qv-selected="' + i + '"></span></legend><div class="tc-qv__values">' +
        o.values.map(function (val) {
          var checked = qv.variant && qv.variant.options[i] === val ? ' checked' : '';
          return '<label class="tc-chip"><input type="radio" class="tc-sr" name="tc-qv-' + esc(self.cfg.sectionId) + '-' + i + '" value="' + esc(val) + '" data-tc-qv-option="' + i + '"' + checked + '><span>' + esc(val) + '</span></label>';
        }).join('') + '</div></fieldset>';
    }).join('');
    var url = product.url || ('/products/' + product.handle);
    return '' +
      '<div class="tc-qv">' +
        '<div class="tc-qv__media"><img data-tc-qv-img alt="' + esc(product.title) + '" src="' + esc(this.sized(product.featured_image, 900)) + '"></div>' +
        '<div class="tc-qv__info">' +
          '<h2 class="tc-display tc-qv__title" id="tc-qv-title-' + esc(this.cfg.sectionId) + '">' + esc(product.title) + '</h2>' +
          '<div class="tc-qv__price" data-tc-qv-price></div>' +
          opts +
          '<div class="tc-qty" role="group" aria-label="' + esc(s.quantity) + '">' +
            '<button type="button" data-tc-qv-step="-1" aria-label="' + esc(s.decrease) + '">' + ICON_MINUS + '</button>' +
            '<span class="tc-qty__val" data-tc-qv-qty aria-live="polite">1</span>' +
            '<button type="button" data-tc-qv-step="1" aria-label="' + esc(s.increase) + '">' + ICON_PLUS + '</button>' +
          '</div>' +
          '<p class="tc-qv__status" data-tc-qv-status aria-live="polite"></p>' +
          '<div class="tc-qv__actions"' + (this.cfg.showBuyNow ? '' : ' style="grid-template-columns:1fr"') + '>' +
            '<button type="button" class="tc-btn tc-btn--primary" data-tc-qv-add>' + esc(s.addToCart) + '</button>' +
            (this.cfg.showBuyNow ? '<button type="button" class="tc-btn tc-btn--outline" data-tc-qv-buy>' + esc(s.buyNow) + '</button>' : '') +
          '</div>' +
          '<a class="tc-qv__more" href="' + esc(url) + '">' + esc(s.viewDetails) + '</a>' +
        '</div>' +
      '</div>';
  };

  Collection.prototype.selectedOptions = function () {
    var p = this.panel('quickview');
    return this.qv.options.map(function (_, i) {
      var c = qs('input[data-tc-qv-option="' + i + '"]:checked', p);
      return c ? c.value : null;
    });
  };

  Collection.prototype.onQvOption = function () {
    if (!this.qv) return;
    var sel = this.selectedOptions();
    this.qv.variant = this.qv.product.variants.filter(function (v) {
      return sel.every(function (x, k) { return v.options[k] === x; });
    })[0] || null;
    this.updateQv();
  };

  Collection.prototype.updateQv = function () {
    var p = this.panel('quickview'), qv = this.qv, s = this.s;
    if (!qv || !p) return;
    var product = qv.product, v = qv.variant;

    qsa('[data-tc-qv-selected]', p).forEach(function (el) {
      var c = qs('input[data-tc-qv-option="' + el.getAttribute('data-tc-qv-selected') + '"]:checked', p);
      el.textContent = c ? c.value : '';
    });

    if (product.variants.length > 1) {
      var sel = this.selectedOptions();
      qsa('input[data-tc-qv-option]', p).forEach(function (input) {
        var i = Number(input.getAttribute('data-tc-qv-option'));
        var trial = sel.slice(); trial[i] = input.value;
        var ok = product.variants.some(function (x) {
          return x.available && trial.every(function (val, k) { return val === null || x.options[k] === val; });
        });
        input.closest('.tc-chip').classList.toggle('is-unavailable', !ok);
      });
    }

    var priceEl = qs('[data-tc-qv-price]', p);
    if (v) {
      var html = '<span>' + this.money(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
        html += '<s><span class="tc-sr">' + esc(s.regularPrice) + ' </span>' + this.money(v.compare_at_price) + '</s><span class="tc-save">' + esc(s.save) + ' ' + pct + '%</span>';
      }
      priceEl.innerHTML = html;
    } else {
      priceEl.innerHTML = '<span>' + esc(s.unavailable) + '</span>';
    }

    var img = qs('[data-tc-qv-img]', p);
    var src = (v && v.featured_image && v.featured_image.src) || product.featured_image;
    if (img && src) img.src = this.sized(src, 900);

    var qtyEl = qs('[data-tc-qv-qty]', p);
    if (qtyEl) qtyEl.textContent = qv.qty;

    var can = !!(v && v.available);
    var status = qs('[data-tc-qv-status]', p);
    if (status) status.textContent = !v ? s.unavailable : (!v.available ? s.soldOut : '');
    [qs('[data-tc-qv-add]', p), qs('[data-tc-qv-buy]', p)].forEach(function (b) {
      if (!b || b.getAttribute('aria-busy') === 'true') return;
      b.disabled = !can;
      if (!b.hasAttribute('data-label')) b.setAttribute('data-label', b.textContent.trim());
      b.textContent = can ? b.getAttribute('data-label') : (!v ? s.unavailable : s.soldOut);
    });
  };

  Collection.prototype.stepQv = function (d) {
    if (!this.qv) return;
    this.qv.qty = Math.max(1, Math.min(99, this.qv.qty + d));
    var el = qs('[data-tc-qv-qty]', this.panel('quickview'));
    if (el) el.textContent = this.qv.qty;
  };

  Collection.prototype.qvSubmit = async function (mode, btn) {
    var v = this.qv && this.qv.variant;
    if (!v || !v.available || btn.getAttribute('aria-busy') === 'true') return;
    this.setBtn(btn, 'busy', mode === 'buy' ? this.s.redirecting : this.s.adding);
    try {
      await this.addItem(v.id, this.qv.qty);
      if (mode === 'buy') { await this.goToCheckout(btn); return; }
      this.setBtn(btn, 'idle');
      var trigger = this.qvTrigger;
      this.closePanel(false);
      this.lastFocus = trigger;
      await this.afterAdd(trigger);
    } catch (err) {
      this.setBtn(btn, 'idle');
      this.toast(this.errMsg(err), 'error');
    }
  };

  /* ---------------------------- Wishlist (UI only) ---------------------------- */
  Collection.prototype.toggleWishlist = function (btn) {
    var on = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.dispatchEvent(new CustomEvent('tanhood:wishlist:toggle', {
      bubbles: true,
      detail: { productId: btn.getAttribute('data-product-id'), handle: btn.getAttribute('data-handle'), active: on }
    }));
  };

  /* ---------------------------- Toast ---------------------------- */
  Collection.prototype.toast = function (message, type) {
    var el = this.toastEl;
    if (!el) return;
    el.textContent = message;
    el.setAttribute('data-type', type || 'info');
    el.classList.add('is-visible');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 4200);
  };

  /* ---------------------------- Boot ---------------------------- */
  var instances = new Map();
  var init = function (scope) {
    qsa('[data-tc-root]', scope || document).forEach(function (root) {
      if (instances.has(root)) return;
      try { instances.set(root, new Collection(root)); } catch (e) { console.error('[Tanhood collection]', e); }
    });
  };
  window.TanhoodCollection = { init: init, instances: instances };

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    qsa('[data-tc-root]', e.target).forEach(function (r) {
      var inst = instances.get(r);
      if (inst) { inst.destroy(); instances.delete(r); }
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
